
import { defineComponent, createVNode, reactive } from 'vue';
import { OioButton, OioNotification } from '@kunlun/vue-ui-antd';
import { Modal } from 'ant-design-vue';
import CoefficientConfigTable from './CoefficientConfigTable.vue';
import { CoefficientRow, queryAllCoefficients, saveCoefficientConfig } from './services';

/**
 * 将输入值转为数值，空值返回 null
 */
function toNumber(value: unknown, isInt: boolean): number | null {
  if (value === '' || value === null || value === undefined) {
    return null;
  }
  const num = isInt ? parseInt(String(value), 10) : parseFloat(String(value));
  return isNaN(num) ? null : num;
}

export default defineComponent({
  name: 'CoefficientConfigDialog',
  components: {
    OioButton
  },
  setup() {
    /**
     * 打开授信等级系数配置弹窗
     */
    const openDialog = async () => {
      try {
        const list = await queryAllCoefficients();
        const rows = reactive<CoefficientRow[]>(
          (list || []).map((item) => ({
            id: item.id,
            creditRating: item.creditRating,
            overLimitTimes: item.overLimitTimes,
            ecommerceCoefficient: item.ecommerceCoefficient,
            offlineCoefficient: item.offlineCoefficient,
            discount: item.discount
          }))
        );

        Modal.confirm({
          title: '授信等级系数配置',
          width: 640,
          icon: null,
          okText: '保存配置',
          cancelText: '取消',
          content: createVNode(CoefficientConfigTable, { rows }),
          onOk: async () => {
            const payload: CoefficientRow[] = rows.map((row) => {
              const isD = row.creditRating === 'D';
              return {
                id: row.id,
                creditRating: row.creditRating,
                // 超账龄次数不允许编辑，D级去除超账龄次数/电商客户/线下客户三个空格
                overLimitTimes: isD ? null : toNumber(row.overLimitTimes, true),
                ecommerceCoefficient: isD ? null : toNumber(row.ecommerceCoefficient, false),
                offlineCoefficient: isD ? null : toNumber(row.offlineCoefficient, false),
                discount: toNumber(row.discount, false)
              };
            });
            await saveCoefficientConfig(payload);
            OioNotification.success('成功', '系数配置保存成功');
          }
        });
      } catch (error) {
        OioNotification.error('错误', '加载系数配置失败');
        // eslint-disable-next-line no-console
        console.error('加载系数配置失败:', error);
      }
    };

    return { openDialog };
  }
});
